import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';

import blogimg9 from "../../img/blog/blog1-image9.png"
import blogimg8 from "../../img/blog/blog1-image8.png"
import blogimg7 from "../../img/blog/blog1-image7.png"
import blogimg6 from "../../img/blog/blog1-image6.png"
import blogimg5 from "../../img/blog/blog1-image5.png"
import blogimg4 from "../../img/blog/blog1-image4.png"
import blogimg3 from "../../img/blog/blog1-image3.png"
import blogimg2 from "../../img/blog/blog1-image2.png"
import blogimg1 from "../../img/blog/blog1-image1.png"
import author from "../../img/icons/author.png"
import dateImg from "../../img/icons/date.png"
import aboutpaycoin from "../../img/about/common-hero-coin.png"
import aboutpaycoin2 from "../../img/about/about-hero-area.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight, faArrowRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import SwiperCore from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';


SwiperCore.use([Navigation, Autoplay]);

const Blog = () => {

    return (
        <>
            <Header />
            <div class="common-hero" style={{ backgroundImage: `url(${require('../../img/bg/common-hero-bg.png')})` }}>
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-5">
                            <div class="main-heading">
                                <h1>Latest News</h1>
                                <div class="space16"></div>
                                <p>Investing in cryptocurrenciesan be exciting journey, but it's essential to approach it with caution and diligence.</p>
                                <div class="subscribe-form">
                                    <form action="#">
                                        <input type="email" placeholder="Email Address" />
                                        <div class="button">
                                            <button class="theme-btn1 btn btn--ripple ripple">Get Started <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} style={{ marginLeft: "5px" }} /></button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-7">
                            <div class="common-hero-images">
                                <div class="image1">
                                    <img src={aboutpaycoin} alt="" />
                                </div>

                                <div class="image2">
                                    <img src={aboutpaycoin2} alt="" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blog-page sp">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg1} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">The Power of Diversification in Cryptocurrency on Investment</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg2} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">The Best Ultimate Crypto Trading Handbook: Strategies, Tips More</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg3} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">The Benefits of Diversification in Cryptocurrency Investment</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg4} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">The Future of Finance: Exploring the World Best Cryptocurrency</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg5} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">Pro Tips for Crypto Traders: Best Expert Strategies to Your Profits</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg6} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">Exclusive Analysis & Commentary on the Cryptocurrency Market</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg7} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">Advanced Techniques and Trends for Experienced Cryptocurrency</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg8} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">Exploring Ethical Considerations in the Cryptocurrency Market</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="blog-box">
                                <div class="image img100 image-anime">
                                    <img src={blogimg9} alt="" />
                                </div>
                                <div class="tags">
                                    <a href="#"><img src={author} alt="" /> Alex Robertson</a>
                                    <a href="#"><img src={dateImg} alt="" /> 7/31/2023</a>
                                </div>
                                <div class="heading1">
                                    <h5><a href="/blogDetail">Navigating Legal Frameworks and Compliance in Trading</a></h5>
                                    <div class="space16"></div>
                                    <p>In today's dynamic financial landscape, a cryptocurrency trading has emerged as.</p>
                                    <div class="space16"></div>
                                    <a href="/blogDetail" class="learn">Read More <span><i class="fa-solid fa-arrow-right"></i></span></a>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="space40"></div>
                    <div class="row">
                        <div class="col-12 m-auto">
                            <div class="theme-pagination text-center">
                                <ul>
                                    <li><a href="#"><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                    <li><a class="active" href="#">01</a></li>
                                    <li><a href="#">02</a></li>
                                    <li>...</li>
                                    <li><a href="#">12</a></li>
                                    <li><a href="#"><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <Footer />
        </>
    )
}

export default Blog